<script setup lang="ts">
const props = defineProps<{
  resourceId?: number
  resourceType?: ResourceType
}>()

const $toast = useToast()
const reason = ref('')
const customReason = ref('')
const emit = defineEmits(['success', 'cancel'])
const reportPostReason = [
  '色情或低俗内容',
  '血腥暴力或令人不适',
  '涉政',
  '违法违禁',
  '引战',
  '人身攻击',
  '虚假消息或不实内容',
  '广告或垃圾内容',
  '侵犯个人隐私',
  '娱乐综艺或明星宣传相关',
  '错误的tag或分区',
  '撞车',
  '转载自制错误或转载无出处',
  '低创或粗俗内容',
  '其他'
]

const reportCommentReason = [
  '色情或低俗内容',
  '血腥暴力或令人不适',
  '涉政',
  '违法违禁',
  '引战',
  '人身攻击',
  '虚假消息或不实内容',
  '广告或垃圾内容',
  '侵犯个人隐私',
  '娱乐综艺或明星宣传相关',
  '其他'
]

const reportUserReason = ['头像违规', '用户名违规', '签名违规', '其他']
const reportReason = () => {
  switch (props.resourceType) {
    case 0:
    case 1:
      return reportPostReason
    case 5:
      return reportUserReason
    default:
      return reportCommentReason
  }
}
function cancel() {
  emit('cancel')
}
function handleChange(e: Event) {
  reason.value = (e.target as HTMLInputElement).value
}
async function submit() {
  if (props.resourceId != null && props.resourceType != null) {
    const r = reason.value === '其他' ? customReason.value : reason.value
    const res = await requestReport(props.resourceId, props.resourceType, r)
    if (res.code === 1) {
      $toast.success('举报成功')
      emit('success')
    } else {
      $toast.error(res.msg)
    }
  } else {
    $toast.info('举报失败')
  }
}
</script>

<template>
  <div class="m-report-form">
    <div class="m-report-form__header">举报</div>
    <m-space vertical gap="8px">
      <n-radio
        v-for="r in reportReason()"
        :key="r"
        :checked="reason === r"
        :value="r"
        @change="handleChange"
      >
        {{ r }}
      </n-radio>
    </m-space>
    <n-input
      v-if="reason === '其他'"
      v-model:value="customReason"
      type="textarea"
      placeholder="请输入举报原因"
      class="m-report-form__custom"
      maxlength="200"
    />
    <n-button
      type="primary"
      block
      strong
      class="m-report-form__button"
      @click="submit"
    >
      提交
    </n-button>
    <n-button block strong class="m-report-form__button" @click="cancel">
      取消
    </n-button>
  </div>
</template>

<style lang="scss" scoped>
.m-report-form {
  width: 100%;
  padding: 0 24px;
  background-color: #fff;
  border-radius: 8px;

  &__header {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    margin-bottom: 24px;
    pointer-events: none;
    font-size: 24px;
    font-weight: bold;
  }
  &__custom,
  &__button {
    margin-top: 12px;
  }
}
</style>
